import React, { useState, useEffect } from 'react';
import api from '../../api';

const BusinessContext = React.createContext({});
const BusinessConsumer = BusinessContext.Consumer;

const BusinessProvider = ({ children }) => {
    const [businessCategories, setBusinessCategories] = useState([]);
    
    const getAllBusinessCategories = async () => {
        const res = await api.get('/business/category');
        setBusinessCategories(res.data.data.businessCategories);
    }

    useEffect(() => {
        getAllBusinessCategories();
    }, [])

    return (
        <BusinessContext.Provider value={{ businessCategories }}>
            {children}
        </BusinessContext.Provider>
    )
}

export { BusinessContext, BusinessProvider, BusinessConsumer };